import React, {useState} from "react";
import {useQueryClient} from "react-query";
import {Stack} from "@mui/material";
import {Button, IconButton, Link} from "@material-ui/core";

import Icons,{ SlrIcon } from "../../../icons";
import { LightTooltip } from "../../../controls";
import { useTripLegSpecialLoads } from "../../../services/trips";


const emptySlr = {
  slr: {count: 0, records: []},
  dgr: {count: 0, records: []},
  temp: {count: 0, records: []},
  avi: {count: 0, records: []},
}

const Tags = (props) => {
  const {tags} = props;
  if (!tags || !Array.isArray(tags) || tags.length === 0) {
    return null;
  }
  return (
    <div style={{ marginBottom: 8, left: -8, width: 100, height: 20}}>
      <div style={{ width: "100%", textAlign:"center"}}>
        <Stack
          direction="row"
          spacing={0}
          justifyContent="space-around"
          alignContent="center"
        >
          {props.tags.map(tag => (
            <div>{tag}</div>
          ))}
        </Stack>
      </div>
    </div>
  )
}


const SpecialLoads = (_props) => {

  const props = {
    ..._props
  }
  const {eventBus, classes} = props;

  const queryClient = useQueryClient();
  const specialLoads = useTripLegSpecialLoads({queryClient, extraKeys: [props.tripLegUuid]});

  const cargoTags = [];
  let bookingUuid = null;

  const SlrRow = (props) => {
    const {bookingUuid, slrReference, specialLoadDescription, expectedWeightKg} = props.data;

    const handleOpenBooking = () => {
      eventBus.trigger("ViewBooking.open",{open: true, bookingUuid});
    }

    return (
      <div style={{display: "flex", whiteSpace: "pre-wrap"}}>
        <div style={{fontWeight: "700", display: "flex", width: "calc(100% - 75px", paddingLeft: 5}}>Reference: <Link component={Button} variant="link" onClick={handleOpenBooking} style={{padding: 0, fontSize: 10, textDecoration: "underline", color: "blue"}}>{slrReference}</Link></div>
        <div style={{display: "flex", textAlign: "left", width: "100%", paddingLeft: 5, paddingRight: 5, overflow: "wrap" }}>{specialLoadDescription}</div>
        <div style={{display: "inline-block", textAlign: "right", width: 60}}>{expectedWeightKg}Kg</div>
      </div>
    )
  }

  const DgrRow = (props) => {

    return (
      <div style={{display: "flex"}}>
      </div>
    )
  }

  const TempRow = (props) => {

    return (
      <div style={{display: "flex"}}>
      </div>
    )
  }

  const AviRow = (props) => {

    return (
      <div style={{display: "flex"}}>
      </div>
    )
  }

  const buildTag = (tagType, tag, icon) => {
    if (tag.records && Array.isArray(tag.records) && tag.records.length > 0) {
      const tagRecord = tag.records[0];
      bookingUuid = tagRecord?.bookingUuid;

      cargoTags.push(
        <LightTooltip
          title={
            <div style={{width: 400}}>
              {tag.records.map(record => {
                switch (tagType) {
                  case "slr":
                    return <SlrRow data={record}></SlrRow>
                  case "dgr":
                    return <DgrRow data={record}></DgrRow>
                  case "temp":
                    return <TempRow data={record}></TempRow>
                  case "avi":
                    return <AviRow data={record}></AviRow>
                }
              })}
            </div>
          }
          arrow placement={"left"}
          interactive
        >
          <IconButton onClick={() => { if (bookingUuid) eventBus.trigger("ViewBooking.open",{open: true, bookingUuid}) }} size="small" >
            <Icons style={{fontSize: 20, padding: 1, }} color="secondary">{icon}</Icons>
          </IconButton>
        </LightTooltip>
      );
    }
  }

  if (specialLoads && specialLoads.data) {
    const {slr, dgr, temp, avi} = specialLoads.data;

    if (slr && slr.count > 0) {
      buildTag("slr", slr, "SlrIcon");
    }
    if (dgr && dgr.count > 0) {
      buildTag("dgr", dgr, "warning_amber");
    }
    if (temp && temp.count > 0) {
      buildTag("temp", temp, "thermostat");
    }
    if (avi && avi.count > 0) {
      buildTag("avi", avi, "AviIcon");
    }

    return (<Tags tags={cargoTags}/>);
  }

  return <></>
}

export default SpecialLoads;
